export default "__VITE_ASSET__52608a9a__"